{
  "admin": {
    "settings": {
      "upsell": {
        "success": "Les modifications ont été enregistrées."
      },
      "attendee_sources": {
        "success": "Les modifications ont été enregistrées."
      },
      "watchdogs": {
        "success": "Les modifications ont été enregistrées.",
        "modification_not_saved": "Des modifications sont en attente d’enregistrement sur cette page."
      },
      "permissions": {
        "success": "Les modifications ont été enregistrées."
      }
    }
  },
  "declaration": {
    "deposit": {
      "success": "Le dépôt a été enregistré avec succès."
    }
  },
  "ticket": {
    "attendees_import": {
      "processing": {
        "title": "Import des invités en cours",
        "message": "Vous pouvez continuer à naviguer sur le site en attendant la fin de l'import"
      },
      "completed": {
        "title": "Importation des invités terminée",
        "label": "vous pouvez consulter l'historique"
      },
      "failed": {
        "title": "Une erreur est survenue.",
        "description": "Veuillez réessayer plus tard."
      },
      "error_message": "Le template contient des erreurs, veuillez les consulter au sein de l'historique."
    },
    "attendees_bulk": {
      "success": {
        "title": "{count} invité(s) ajouté(s) avec succès."
      },
      "partial": {
        "title": "{created} invité(s) ajouté(s), {failed} invité(s) déjà existant(s)."
      },
      "failed": {
        "title": "Aucun invité n'a pu être ajouté, ils sont déjà existants."
      }
    },
    "deposit_management_page": {
      "eps": {
        "processing": {
          "title": "Dépôt EPS en cours",
          "label": "Participant(s) {processed}/{total}",
          "preparing": "Préparation du dépôt EPS",
          "stages": {
            "FETCHING_EVENT_DOCUMENTS": "Récupération des documents de l’événement",
            "FETCHING_ATTENDEE_DOCUMENTS": "Récupération des documents de l’invité {current}/{total}",
            "FETCHING_LEGAL_ENTITY_DOCUMENTS": "Récupération des documents de la personne morale {current}/{total}",
            "AUTHENTICATING": "Connexion à EPS",
            "CREATING_EVENT": "Création de l’événement EPS",
            "PROCESSING_ATTENDEES": "Enregistrement des participants dans EPS {current}/{total}"
          }
        },
        "completed": {
          "title": "Dépôt EPS terminé",
          "label": "Le dépôt EPS a été effectué avec succès"
        },
        "failed": {
          "title": "Échec du dépôt EPS",
          "label": "Le dépôt EPS n'a pas pu être effectué"
        }
      },
      "documents_download_modal": {
        "completed": {
          "title": "La génération des documents est terminée",
          "label": "Accéder aux documents"
        },
        "failed": {
          "title": "Une erreur est survenue lors de la génération des documents",
          "description": "Veuillez réessayer plus tard."
        },
        "automatic_deposit_sent": {
          "title": "Succès d'envoi du dépot automatique",
          "description": "Vous pouvez continuer à naviguer sur le site, une référence sera bientôt disponible"
        },
        "manual_deposit_sent": {
          "title": "Succès d'envoi du dépot manuel",
          "description": "Une référence à été générée et est disponible dans votre dépôt"
        },
        "deposit_error": {
          "title": "Erreur lors de l'envoi du dépôt",
          "description": "Vérifiez les informations saisies et réessayez."
        }
      }
    },
    "signatures": {
      "create": {
        "processing": {
          "title": "Envoi en signature",
          "label": "Traitement en cours..."
        },
        "completed": {
          "title": "Envoi en signature terminé",
          "label": "{count} procédure(s) envoyée(s)",
          "label_redirect": "Voir les procédures envoyées"
        },
        "completed_with_skipped": {
          "title": "Envoi en signature terminé ({skipped} contrat(s) ignoré(s))"
        },
        "partial_failure": {
          "title": "Traitement terminé, {count} contrat(s) n'ont pas pu être envoyé(s)",
          "label": "{count} procédure(s) envoyée(s)"
        },
        "total_failure": {
          "title": "Échec de l'envoi en signature ({count} contrat(s))"
        },
        "failed": {
          "title": "Une erreur est survenue",
          "description": "Veuillez contacter le support client."
        },
        "skipped": {
          "title": "Envoi en signature ignoré",
          "label": "des procédures de signature sont déja créées pour les invités sélectionnés"
        },
        "skipped_with_batch": {
          "title": "{count} contrat(s) ignoré(s)",
          "label": "Des procédures de signature existent déjà pour ces invités"
        }
      },
      "cancel": {
        "processing": {
          "title": "Annulation des procédures de signature en cours liées",
          "label": "Traitement en cours..."
        },
        "completed": {
          "title": "Annulations terminées",
          "label": "{count} procédure(s) annulée(s)",
          "label_redirect": "Voir les procédures annulées"
        },
        "partial_failure": {
          "title": "Traitement terminé, {count} procédure(s) n'ont pas pu être annulée(s)."
        },
        "total_failure": {
          "title": "Échec de l'annulation des signatures ({count} procédure(s))"
        },
        "failed": {
          "title": "Erreur lors de l'annulation des signatures.",
          "description": "Veuillez contacter le support client."
        },
        "skipped": {
          "title": "Annulation des procédures de signature",
          "label": "Aucune procédure de signature active à annuler"
        }
      }
    },
    "clone": {
      "completed": {
        "title": "Le clonage du ticket est terminé",
        "label": "Accéder au ticket",
        "label_refresh": "Vous pouvez rafraîchir la page",
        "click_here": "En cliquant ici"
      }
    },
    "expenses": {
      "process-import": {
        "completed": {
          "title": "Import des dépenses terminé avec succès",
          "label": "Vous pouvez consulter l'historique"
        },
        "pending": {
          "title": "L'import des {expenseType} est en cours",
          "description": "Vous pouvez continuer à naviguer sur le site en attendant la fin de l'import"
        },
        "failed": {
          "title": "Une erreur est survenue lors de l'import des dépenses",
          "description": "Veuillez réessayer plus tard."
        }
      },
      "generate-template": {
        "processing": {
          "title": "Génération en cours",
          "message": "Vous pouvez continuer à naviguer sur le site en attendant la fin de la génération"
        },
        "completed": {
          "title": "Génération du template terminée",
          "label": "Voir le template"
        },
        "skipped": {
          "title": "Génération du template ignorée",
          "label": "Veuillez réessayer plus tard."
        },
        "failed": {
          "title": "Une erreur est survenue.",
          "description": "Veuillez réessayer plus tard."
        }
      },

      "generate-contract-zip-file": {
        "processing": {
          "title": "Génération en cours",
          "message": "Vous pouvez continuer à naviguer sur le site en attendant la fin de la génération"
        },
        "completed": {
          "title": "La génération du zip est terminée",
          "label": "Accéder au zip"
        },
        "failed": "Une erreur est survenue lors de la génération du zip."
      }
    },
    "info": {
      "agency-export": {
        "title": "Génération du fichier en cours",
        "message": "Vous pouvez continuer à naviguer sur le site en attendant la fin de la génération"
      },
      "agency-export-completed": {
        "title": "Génération du fichier terminée",
        "message": "Accéder au téléchargement"
      },
      "failed": {
        "message": "Une erreur est survenue lors de la génération du fichier."
      }
    }
  }
}
